import React, { Component } from 'react'
import { Grid, Box, IconButton} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import useStyles from './styles/SectionCarouselStyle'
import Carousel from "react-spring-3d-carousel";
import CarouselItem from './CarouselItem'
import {maxWidthForSection} from '../../../services/Utils'
import { config } from "react-spring";
import {ReactComponent as ArrowLeft} from '../../../assets/ArrowLeft.svg'
import {ReactComponent as ArrowRight} from '../../../assets/ArrowRight.svg'

// Constants:
const carouselItemWidthForXLScreens = maxWidthForSection * 0.75;

// The component itself:
class SectionCarousel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      goToSlide: 0,
      offsetRadius: 1,
      config: config.default,
      windowWidth: window.innerWidth,
    }
    // bind functions to 'this' instance:
    this.handleResize = this.handleResize.bind(this);
    this.goToSlide = this.goToSlide.bind(this);
  }

  goToSlide(slideIndex, direction) {
    let goToIndex;
    if (direction === "right") {
      goToIndex = (slideIndex + 1) % this.props.playlist.length
    } else if (direction === "left") {
      if (slideIndex === 0) {
        goToIndex = this.props.playlist.length - 1;
      } else {
        goToIndex = (slideIndex - 1) % this.props.playlist.length;
      }
    }
    this.setState({goToSlide: goToIndex})
  }

  componentDidMount() {
    // the handleResize method will be invoked every time the window will get resized
    window.addEventListener('resize', this.handleResize);
  }

  // This method is invoked every time the window is resized.
  handleResize() {
    this.setState({
      windowWidth: window.innerWidth,
    })
  }

  getVideoPreviewBoxHeight() {
    const boxWidth = this.state.windowWidth < maxWidthForSection ? this.state.windowWidth * 0.75 : carouselItemWidthForXLScreens
    const height = (boxWidth * 9) / 16
    return height
  }

  // Invoked every time any of the carousel items are clicked on.
  onCarouselItemClick(index) {
    // If we got the index of the main (centered) item.
    if (index === this.state.goToSlide) {
      // Do something: Get the watcher API.
      this.props.onVideoClicked(index)
    } else {
      // if a secondary item is clicked, we will make it the main item:
      this.setState({goToSlide: index})
    }
  }

  // Renders a 3d carousel component where the slides/items are previews to videos
  // of the given playlist.
  renderCarousel(playlist) {
    const slides = this.props.playlist.map((slide, index) => {
      return {
        content: <CarouselItem
                  main={index===this.state.goToSlide}
                  style={{height: this.getVideoPreviewBoxHeight(),
                          width: this.state.windowWidth < maxWidthForSection ? this.state.windowWidth * 0.75 : carouselItemWidthForXLScreens,
                          objectFit: 'cover'}}
                  videoDetails={slide}
                 />,
        key: index,
        onClick: ()=>this.onCarouselItemClick(index)
      }
    })
    /*
    Note: The carousel component renders the main item with its given size,
    whilst the rest of the items are rendered with half of their size.
    For example, If all of the items are 40 x 40, then the main item will be rendered
    with 40 x 40, and the rest will be rendered with 20 x 20.
    */
    return (
      <Carousel
        slides={slides}
        goToSlide={this.state.goToSlide}
        offsetRadius={this.state.offsetRadius}
        animationConfig={this.state.config}
      />
    );
  }

  renderLeftArrow() {
    const classes = this.props.classes
    const fromLeft = this.state.windowWidth < maxWidthForSection ? (this.state.windowWidth * 0.125 - 26.5) : (this.state.windowWidth - carouselItemWidthForXLScreens) / 2 - 26.5

    return (
      <Grid item
        className={`${classes.arrowIconContainer} section-carousel-arrows-container`}
        style={{left: fromLeft,
                marginTop: this.getVideoPreviewBoxHeight() / 2 - 26,
              }}
      >
        <IconButton
          onClick={()=>this.goToSlide(this.state.goToSlide, "left")}
        >
          <ArrowLeft
            className={`${classes.leftArrow} section-carousel-arrows`}
          />
        </IconButton>
      </Grid>
    )
  }

  renderRightArrow() {
    const classes = this.props.classes
    const fromRight = this.state.windowWidth < maxWidthForSection ? (this.state.windowWidth * 0.125 - 26.5) : (this.state.windowWidth - carouselItemWidthForXLScreens) / 2 - 26.5

    return (
      /* The main item takes exactly 50% of the screen's width.
      The arrow button is a ~square of 53x52 pixels (The arrow itself is 29x28 [given\static], and has a 12px padding).
      These 2 properties explain why the styling below enforces the arrow to be according to the design.
      */
      <Grid item
        className={`${classes.arrowIconContainer} section-carousel-arrows-container`}
        style={{right: fromRight,
                marginTop: this.getVideoPreviewBoxHeight() / 2 - 26,
              }}
      >
        <IconButton
          onClick={()=>this.goToSlide(this.state.goToSlide, "right")}
        >
          <ArrowRight
            className={`section-carousel-arrows`}
          />
        </IconButton>
      </Grid>
    )
  }

  // The render function for this component.
  render() {
    const classes = this.props.classes
    const currentVideo = this.props.playlist[this.state.goToSlide]
    return (
      <Grid container spacing={1} className={classes.carouselContainer}>
        <Grid item lg={12} md={12} className={classes.carouselContainer} style={{minHeight: this.getVideoPreviewBoxHeight()}}>
          {this.renderCarousel(this.props.playlist)}
        </Grid>
        <Grid>
          {/* Arrows for carousel: */}
          {this.renderLeftArrow()}
          {this.renderRightArrow()}
        </Grid>

        <Grid
          container
          direction="column"
          alignItems="center"
          justify="center"
          >
          <Grid item
                onClick={()=>this.onCarouselItemClick(this.state.goToSlide)}
                className={classes.titlesContainer}
                style={{width: this.state.windowWidth < maxWidthForSection ? this.state.windowWidth * 0.75 : carouselItemWidthForXLScreens}}
          >
            <Box className={`${classes.mainTitle} section-carousel-item-title`}>
              {currentVideo.title}
            </Box>
            <Grid
              item
              style={{width: this.state.windowWidth < maxWidthForSection ? this.state.windowWidth * 0.75 : carouselItemWidthForXLScreens}}
              hidden={!currentVideo.description}
            >
              <Box className={`${classes.secondaryTitle} section-carousel-item-subtitle`}>
                {currentVideo.description}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}
export default withStyles(useStyles)(SectionCarousel)
